import { readAuthToken } from './authStorage';

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');

export function apiUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  let normalizedPath = path.startsWith('/') ? path : `/${path}`;

  // Prevent accidental double prefix when base already ends with "/api"
  // and call sites also use "/api/...".
  if (API_BASE_URL.endsWith('/api') && normalizedPath.startsWith('/api/')) {
    normalizedPath = normalizedPath.slice(4);
  }

  return `${API_BASE_URL}${normalizedPath}`;
}

export function apiFetch(input: string, init?: RequestInit): Promise<Response> {
  const token = readAuthToken();
  const headers = new Headers(init?.headers || {});

  if (!headers.has('Accept')) {
    headers.set('Accept', 'application/json');
  }

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(apiUrl(input), {
    ...init,
    headers,
  });
}

export async function readApiJson<T = unknown>(response: Response): Promise<T | null> {
  const text = await response.text();

  if (!text.trim()) {
    return null;
  }

  try {
    return JSON.parse(text) as T;
  } catch {
    throw new Error(`Le serveur a repondu un format non JSON (HTTP ${response.status})`);
  }
}
